/* Live Google rating/review-count for the Studio Services mega menu.
   Reads per-studio config from .js-google-rating data attributes:
     data-api-key   Google Places API key (referrer-restricted; blank = do nothing,
                    server-rendered fallback values stay)
     data-place-id  optional Places ID -> Place Details lookup
     data-query     name+address text -> Text Search lookup (used when no place id)
     data-cache-key localStorage cache slot
   Results cached for 24h so the API is hit at most once per visitor per day. */
(function () {
  'use strict';

  var CACHE_TTL = 24 * 60 * 60 * 1000;

  function readCache(key) {
    try {
      var raw = localStorage.getItem('gr:' + key);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data.ts || Date.now() - data.ts > CACHE_TTL) return null;
      return data;
    } catch (e) {
      return null;
    }
  }

  function writeCache(key, rating, count) {
    try {
      localStorage.setItem('gr:' + key, JSON.stringify({ ts: Date.now(), rating: rating, count: count }));
    } catch (e) { /* private mode etc. */ }
  }

  function render(el, rating, count) {
    if (!rating || !count) return;
    var value = el.querySelector('.js-google-rating-value');
    var countEl = el.querySelector('.js-google-rating-count');
    var stars = el.querySelector('.megamenu__reviews-stars');
    if (value) value.textContent = Number(rating).toFixed(1);
    if (countEl) countEl.textContent = count;
    if (stars) {
      var full = Math.round(Number(rating));
      full = Math.max(0, Math.min(5, full));
      stars.textContent = new Array(full + 1).join('★') + new Array(5 - full + 1).join('☆');
    }
  }

  function fetchDetails(key, placeId) {
    var url = 'https://places.googleapis.com/v1/places/' + encodeURIComponent(placeId) +
      '?fields=rating,userRatingCount&key=' + encodeURIComponent(key);
    return fetch(url).then(function (r) {
      if (!r.ok) throw new Error('places details ' + r.status);
      return r.json();
    }).then(function (d) {
      return { rating: d.rating, count: d.userRatingCount };
    });
  }

  function fetchSearch(key, query) {
    return fetch('https://places.googleapis.com/v1/places:searchText', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Goog-Api-Key': key,
        'X-Goog-FieldMask': 'places.rating,places.userRatingCount'
      },
      body: JSON.stringify({ textQuery: query, pageSize: 1 })
    }).then(function (r) {
      if (!r.ok) throw new Error('places search ' + r.status);
      return r.json();
    }).then(function (d) {
      var place = d.places && d.places[0];
      if (!place) throw new Error('no place match');
      return { rating: place.rating, count: place.userRatingCount };
    });
  }

  function init() {
    /* Lookups switched off 2026-10-07: each one is a billed Google request.
       The server-rendered rating and count stay in place. */
    return;

    Array.prototype.forEach.call(els, function (el) {
      var key = el.getAttribute('data-api-key');
      if (!key) return;

      var cacheKey = el.getAttribute('data-cache-key') || el.getAttribute('data-query') || 'default';
      var cached = readCache(cacheKey);
      if (cached) {
        render(el, cached.rating, cached.count);
        return;
      }

      var placeId = el.getAttribute('data-place-id');
      var query = el.getAttribute('data-query');
      var request = placeId ? fetchDetails(key, placeId) : (query ? fetchSearch(key, query) : null);
      if (!request) return;

      request.then(function (res) {
        if (res.rating && res.count) {
          writeCache(cacheKey, res.rating, res.count);
          render(el, res.rating, res.count);
        }
      }).catch(function () { /* keep server-rendered fallback */ });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
